import { NavLink, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import FilterNav from './FilterPages/FilterNav';
import TopGainers from './FilterPages/TopGainers';
import TopLosers from './FilterPages/TopLosers';
import Trending from './FilterPages/TrendingCoins';
import TopMarketCap from './FilterPages/TopMarketCap';
import DeFi from './FilterPages/DeFi';
import NFT from './FilterPages/NFT';
import AiTokens from './FilterPages/AITokens';
import Meme from './FilterPages/MemeCoins';
const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;




const CACHE_KEY = 'apiData';
const CACHE_DURATION = 60 * 1000 * 4; // 4 minute
const REFRESH_THRESHOLD = 60 * 1000; // 15 seconds

// Save to cache with expiry
const setCache = (key, data, ttl) => {
  const now = Date.now();
  const expiry = now + ttl;
  const item = { data, timestamp: now, expiry };
  localStorage.setItem(key, JSON.stringify(item));
};

// Load from cache and decide if it's fresh enough
const getCache = (key) => {
  const cached = localStorage.getItem(key);
  if (!cached) return null;

  const { data, timestamp, expiry } = JSON.parse(cached);
  const now = Date.now();

  if (now > expiry) {
    localStorage.removeItem(key);
    return null;
  }

  const isStale = now - timestamp > REFRESH_THRESHOLD;

  return { data, isStale };
};



const CoinList = () => {
	const [activeTab, setActiveTab] = useState('all_crypto');
	const [loading, setLoading] = useState(true);
	const [results, setResults] = useState([]);
	const [totalPages, setTotalPages] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [articles, setArticles] = useState([]);

	const fetchResults = async () => {
	    const query = new URLSearchParams({ page_number: currentPage }).toString();
	    try {
	      const response = await fetch(`${apiUrl}/get-coins-data?${query}`);
	      const data = await response.json();
	      setCache(CACHE_KEY, data, CACHE_DURATION);
	      setResults(data.resluts);
	      setTotalPages(data.total_pages);
	      setLoading(false); 
	    } catch (error) {
	      setLoading(false);
	      console.error("Error fetching data:", error);
	    }
  	};
  	useEffect(() => {
  		if(activeTab === 'all_crypto') {
		    fetchResults();
		  }
		  window.scrollTo({ top: 0, behavior: "smooth" });
  	}, [currentPage, activeTab]);

  	const handlePageChange = (direction) => {
		  setCurrentPage((prevPage) => {
		    if (direction === 'prev') {
		      return Math.max(prevPage - 1, 1); // Minimum page is 1
		    } else if (direction === 'next') {
		      return Math.min(prevPage + 1, totalPages); // Maximum page is totalPages
		    }
		    return prevPage;
		  });
		};

return (

<div className="coinlist_wrapper">
	<div className="coinlist_mainsec">
		<div className="container">
			<div className="row">
				<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
					<div className="toptitlebox">
						<div className="titlesec">
							<h2>Live Crypto Prices</h2>
							<p>Real-time cryptocurrency market data and price movements</p>
						</div>
					</div>
					
					<div className="coininfo_boxsec">
						<FilterNav activeTab={activeTab} setActiveTab={setActiveTab} currentPage={currentPage} setCurrentPage={setCurrentPage}/>
						{activeTab === 'all_crypto' &&
							<>
								<div className="table_mainsec">
									<div className="table-responsive">
										<table className="table">
											<thead>
												<tr>
													<th>Coin</th>
													<th>Price</th>
													<th>24h Change</th>
													<th>Volume</th>
													<th>Chart</th>
												</tr>
											</thead>
											
											<tbody>
												{results.length ? (
						                        results.map((result, index) => (
						             <tr key={result.id}>
													<td>
														<div className="coinnamebox">
															<div className="logobox"><img src={result.image} alt={result.name} /></div>
															
															<div className="coinname">
																<div className="shortname">{result.symbol}</div>
																<div className="fullname">{result.name}</div>
															</div>
														</div>
													</td>
													
													<td>
														<div className="">${result.current_price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
													</td>
													
													<td>
														<div className="changeinfo">
															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="green"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>
															
															<span className="persentage green">{result.price_change_percentage_24h != null
																? result.price_change_percentage_24h.toLocaleString('en-US', {
																	minimumFractionDigits: 2,
																	maximumFractionDigits: 2
																  }) + '%'
																: 'N/A'}</span>
														</div>
														
														<div className="price">${result.total_volume.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
													</td>
													
													<td>{result.total_volume}</td>
													
													<td>
														<div className="chartgraph">
															<img alt={result.name} src={`https://www.coingecko.com/coins/${result.coin_id}/sparkline.svg`} />
														</div>
													</td>
												</tr>
												))
	                      ) : (
	                        <tr>
	                          <td colSpan="5">No campaigns found</td>
	                        </tr>
	                      )}
											</tbody>
										</table>
									</div>
								</div>
								<div className="btn_mainsec">
									<button
									  className="btn_style"
									  onClick={() => handlePageChange('prev')}
									  disabled={currentPage === 1}
									>
									  Previous
									</button>

									<button
									  className="btn_style"
									  onClick={() => handlePageChange('next')}
									  disabled={currentPage === totalPages}
									>
									  Next
									</button>
								</div>
							</>
							}
							{activeTab === 'top_gainers' && <TopGainers loading={loading} setLoading={setLoading} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} setTotalPages={setTotalPages} />}
						  {activeTab === 'top_losers' && <TopLosers loading={loading} setLoading={setLoading} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} setTotalPages={setTotalPages} />}
						  {activeTab === 'trending' && <Trending loading={loading} setLoading={setLoading} activeTab={activeTab} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} setTotalPages={setTotalPages}/>}
						  {activeTab === 'top_marketcap' && <TopMarketCap loading={loading} setLoading={setLoading} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} setTotalPages={setTotalPages}/>}
						  {activeTab === 'defi' && <DeFi loading={loading} setLoading={setLoading} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} setTotalPages={setTotalPages}/>}
						  {activeTab === 'nft' && <NFT loading={loading} setLoading={setLoading} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} setTotalPages={setTotalPages}/>}
						  {activeTab === 'ai' && <AiTokens loading={loading} setLoading={setLoading} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} setTotalPages={setTotalPages}/>}
						  {activeTab === 'meme' && <Meme loading={loading} setLoading={setLoading} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} setTotalPages={setTotalPages}/>}
					</div>
				</div>
			</div>
		</div>
	</div>
	{loading && (
		<div className="loader_mainbox">
			<div className="loader_mainsec">
				<div className="loader market-spinner">
					<svg class="icon" viewBox="0 0 24 24" width="20" height="20" aria-label="Loading market data">
					<polyline points="22 7 13.5 15.5 8.5 10.5 2 17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<polyline points="16 7 22 7 22 13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</div>
					 
				<div className="text-loader">
					<span>C</span>
					<span>O</span>
					<span>I</span>
					<span>N</span>
					<span>V</span>
					<span>I</span>
					<span>E</span>
					<span>W</span>
					<span>S</span>
				</div>
			</div>
		</div>
	)}
</div>

);
};

export default CoinList;